import { center } from '@styled-system/patterns';
import { token } from '@styled-system/tokens';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PuffLoader } from 'react-spinners';

import { useAuth } from '@/features/auth/hooks/useAuth';

export function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, login } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/analysis/products', { state: { fromHome: true } });
      } else {
        login();
      }
    }
  }, [isLoading, isAuthenticated, navigate, login]);

  if (isLoading) {
    return (
      <div className={center({ h: '100vh', w: '100vw' })}>
        <PuffLoader color={token.var('colors.accent.primary')} size={60} />
      </div>
    );
  }

  return null;
}
